// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--2yuSF","content":"content--29PST","buttons":"buttons--2e8qy"};